// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html {\n  --color-blue-100-opacity-50: #e3f2ff80;\n  --side-bar-width: 400px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
